<template>
  <el-card>
    <div slot="header" class="page-title">
      <div class="page-hedaer">
        <h4 class="page-title">补贴概览</h4>
        <span class="title-info">(统计用户报单返利佣金与订单数)</span>
      </div>
      <order-claim></order-claim>
    </div>

    <!-- 4宫格布局 -->
    <el-row :gutter="20">
      <!-- 模块1：今日统计 -->
      <el-col :span="12">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-title">
            <div>今日统计</div>
          </div>
          <el-row :gutter="10">
            <el-col :span="8">
              <div class="stat-item">
                <div class="stat-label">今日佣金</div>
                <div class="stat-value text-danger">
                  ¥{{ formatMoney(todayStats.commission) }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-item">
                <div class="stat-label">今日订单数</div>
                <div class="stat-value text-primary">
                  {{ todayStats.orderCount }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-item">
                <div class="stat-label">今日支付金额</div>
                <div class="stat-value text-success">
                  ¥{{ formatMoney(todayStats.payAmount) }}
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>

      <!-- 模块2：补贴预估 -->
      <el-col :span="12">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-title">补贴预估</div>
          <el-row :gutter="10">
            <el-col :span="8">
              <div class="stat-item">
                <div class="stat-label">近7日预估</div>
                <div class="stat-value text-danger">
                  ¥{{ formatMoney(commissionStats.sevenDayCommission) }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-item">
                <div class="stat-label">上月预估</div>
                <div class="stat-value text-danger">
                  ¥{{ formatMoney(commissionStats.lastMonthCommission ) }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-item">
                <div class="stat-label">本月预估</div>
                <div class="stat-value text-danger">
                  ¥{{ formatMoney(commissionStats.monthCommission ) }}
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 20px">
      <!-- 模块3：佣金统计图表 -->
      <el-col :span="24">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-title">
            <span>有效订单数与佣金统计</span>
            <el-radio-group v-model="chartPeriod" size="mini" @change="fetchChartData">
              <el-radio-button label="week">7天</el-radio-button>
              <el-radio-button label="month">30天</el-radio-button>
            </el-radio-group>
          </div>
          <div ref="commissionChart" style="width: 100%; height: 600px"></div>
        </el-card>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import api from "@/api";
import OrderClaim from "@/components/OrderClaim.vue";
import * as echarts from "echarts";

export default {
  name: "Overview",
  components: {
    OrderClaim,
  },
  data() {
    return {
      // 今日统计数据
      todayStats: {
        commission: 0,
        orderCount: 0,
        payAmount: 0,
      },
      // 佣金统计数据
      commissionStats: {
        monthCommission : 0,
        lastMonthCommission : 0,
        sevenDayCommission : 0,
      },
      // 订单数据
      orders: [],
      loading: false,
      commissionChart: null,
      orderChart: null,
      // 图表相关
      chartPeriod: "week",
      orderPeriod:"week",
      chartStats: {
        items: [],
        totalCommission: 0,
        totalOrderCount: 0,
        totalPayAmount: 0
      }
    };
  },
  mounted() {
    this.fetchStats();
    this.fetchChartData();
    this.fetchOrderChart()
  },
  beforeDestroy() {
    if (this.commissionChart) {
      this.commissionChart.dispose();
    }
    if (this.orderChart) {
      this.orderChart.dispose();
    }
  },
  methods: {
    async fetchStats() {
      this.loading = true;
      try {
        // 获取概览统计数据
        const statsRes = await api.get("/api/overview/stats");
        if (statsRes.data) {
          this.todayStats.commission = statsRes.data.today_commission || 0;
          this.todayStats.orderCount = statsRes.data.today_order_count || 0;
          this.todayStats.payAmount = statsRes.data.today_pay_amount || 0;
          this.commissionStats.sevenDayCommission = statsRes.data.seven_day_commission || 0;
          this.commissionStats.lastMonthCommission  = statsRes.data.last_month_commission || 0;
          this.commissionStats.monthCommission  = statsRes.data.month_commission || 0;
        }
      } catch (e) {
        console.error("获取统计数据失败:", e);
      } finally {
        this.loading = false;
      }
    },
    async fetchChartData() {
      try {
        const res = await api.get("/api/overview/chart", {
          params: { period: this.chartPeriod }
        });
        if (res.data) {
          this.chartStats = {
            items: res.data.items || [],
            totalCommission: res.data.total_commission || 0,
            totalOrderCount: res.data.total_order_count || 0,
            totalPayAmount: res.data.total_pay_amount || 0
          };
          this.initCommissionChart();
        }
      } catch (e) {
        console.error("获取图表数据失败:", e);
      }
    },
    formatMoney(amount) {
      return ((amount || 0) / 100).toFixed(2);
    },
    initCommissionChart() {
      if (!this.$refs.commissionChart) return;
      
      if (this.commissionChart) {
        this.commissionChart.dispose();
      }
      this.commissionChart = echarts.init(this.$refs.commissionChart);
      
      const days = this.chartStats.items.map(item => item.date);
      const commissions = this.chartStats.items.map(item => (item.commission / 100).toFixed(2));
      const orderCounts = this.chartStats.items.map(item => item.order_count || 0);
      
      const option = {
        tooltip: { 
          trigger: 'axis',
        },
        axisPointer: {
          link: [{ xAxisIndex: 'all' }],
          label: { backgroundColor: '#777' }
        },
        legend: {
          data: ['佣金', '有效订单数'],
          top: 0
        },
        grid: [
          {
            left: 60,
            right: 20,
            top: 30,
            height: 250,
            containLabel:true
          },
          {
            left: 60,
            right: 20,
            top: 350,
            height: 250,
            containLabel:true
          }
        ],
        xAxis: [
          {
            type: 'category',
            data: days,
            gridIndex: 0,
            axisLabel: { show: false },
            axisTick: { show: false }
          },
          {
            type: 'category',
            data: days,
            gridIndex: 1,
            axisLabel: { show: true },
            axisTick: { show: true }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '佣金(元)',
            gridIndex: 0,
            nameLocation: 'middle',
            nameGap: 40,
            minInterval: 1
          },
          {
            type: 'value',
            name: '有效订单数',
            gridIndex: 1,
            nameLocation: 'middle',
            nameGap: 40,
            minInterval: 1
          }
        ],
        series: [
          {
            name: '佣金',
            data: commissions,
            type: 'bar',
            barWidth: '50%',
            itemStyle: { color: '#f56c6c' },
            xAxisIndex: 0,
            yAxisIndex: 0
          },
          {
            name: '有效订单数',
            data: orderCounts,
            type: 'line',
            smooth: true,
            itemStyle: { color: '#409eff' },
            areaStyle: { 
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(64, 158, 255, 0.3)' },
                { offset: 1, color: 'rgba(64, 158, 255, 0.05)' }
              ])
            },
            xAxisIndex: 1,
            yAxisIndex: 1
          }
        ]
      };
      
      this.commissionChart.setOption(option);
    },
    fetchOrderChart() {}

  },
};
</script>

<style scoped>
.page-title{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.page-hedaer{
  display: flex;
  align-items: center;
}
.page-title{
  margin: 0;
}
.title-info{
  margin-left: 5px;
  font-size: 12px;
  color:#909399;
}
.stat-card {
  background: #fff;
  border-radius: 8px;
}

.stat-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chart-stats {
  margin-bottom: 10px;
  font-size: 14px;
  color: #606266;
}

.chart-stats span {
  margin-right: 20px;
}


.stat-item {
  text-align: center;
}

.stat-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}

.text-success {
  color: #67c23a;
}

.text-primary {
  color: #409eff;
}

.text-danger {
  color: #f56c6c;
}

.text-info {
  color: #909399;
}
</style>
